import { c as _c } from "react/compiler-runtime";
import { Button, Heading, LayoutStack } from 'design-system/server';
import { useTranslations } from 'next-intl';
import styles from './ProhibitedNotice.module.css';
function ProhibitedNotice(t0) {
  const $ = _c(15);
  const {
    backHref
  } = t0;
  const t = useTranslations("nextjs.donate");
  let t1;
  if ($[0] !== t) {
    t1 = t("prohibited_headline");
    $[0] = t;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = <Heading level="heading-xs">{t1}</Heading>;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t) {
    t3 = t("prohibited_notice");
    $[4] = t;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t3) {
    t4 = <p>{t3}</p>;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== backHref || $[9] !== t) {
    t5 = backHref && <Button href={backHref} as="a">{t("prohibited_call_to_action")}</Button>;
    $[8] = backHref;
    $[9] = t;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t2 || $[12] !== t4 || $[13] !== t5) {
    t6 = <div className={styles.outerContainer}><LayoutStack space="300" className={styles.container}>{t2}{t4}{t5}</LayoutStack></div>;
    $[11] = t2;
    $[12] = t4;
    $[13] = t5;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  return t6;
}
export default ProhibitedNotice;